import * as yup from 'yup';

export const getPlanSchema = (isFixedBillingCycle: boolean) => {
  return yup.object().shape({
    name: yup.string().required('Plan name is required'),
    displayName: yup.string().required(),
    description: yup
      .string()
      .notRequired()
      .max(300, 'Description must not exceed 300 characters'),
    // billingFrequency: yup.string().required('Billing frequency is required'),
    price: yup
      .number()
      .min(0.8, 'Price must be greater than 0.8$')
      .required('Price is required'),
    firstPaymentDiscount: yup.number().notRequired(),
    billingCycleValue: isFixedBillingCycle
      ? yup
          .number()
          .required('Billing cycle value is required')
          .min(1, 'Billing cycle must be at least 1')
      : yup.number().notRequired()
    // trialPeriod: yup.number().required('Trial period is required'),
    // trialPeriodUnit: yup.string().required('Trial period unit is required'),
    // billingCycle: yup.string().required('Billing cycle is required'),
    // billingCycleValue: yup.number().required('Billing cycle value is required')
  });
};
